import useId from '../utils/useId';
import * as React from 'react';
export const jcbSvg = React.forwardRef(function jcbSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_jcb__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M5 24h4.4c1.001 0 2.2-1.194 2.2-2.133V8H7.2C6.199 8 5 9.195 5 11.2V24Z',
        fill: '#047AB1',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.497 18.816A9.281 9.281 0 0 1 5 18.475v-1.173c.63.377 1.35.59 2.09.618.847 0 1.32-.576 1.32-1.365v-3.221h2.09v3.221c0 1.259-.682 2.261-3.003 2.261Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M12.7 24h4.4c1.001 0 2.2-1.194 2.2-2.133V8h-4.4c-1 0-2.2 1.195-2.2 3.2V24Z',
        fill: '#D42D06',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M12.7 14.08c.638-.597 1.738-.97 3.52-.885.968.043 1.98.32 1.98.32v1.184a4.572 4.572 0 0 0-1.903-.608c-1.353-.117-2.178.619-2.178 1.91 0 1.29.825 2.026 2.178 1.92a4.639 4.639 0 0 0 1.903-.62v1.174s-1.012.288-1.98.33c-1.782.086-2.882-.287-3.52-.885v-3.84Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M20.4 24h4.4c1 0 2.2-1.194 2.2-2.133V8h-4.4c-1.001 0-2.2 1.195-2.2 3.2V24Z',
        fill: '#67B637',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M25.9 17.28c0 .854-.682 1.387-1.595 1.387H20.4v-5.333h3.553l.253.01c.803.043 1.397.502 1.397 1.291 0 .619-.407 1.152-1.144 1.28v.032c.814.053 1.44.555 1.44 1.333Zm-2.805-3.104a1.036 1.036 0 0 0-.143-.01h-1.32v1.344h1.463c.275-.064.506-.31.506-.672 0-.363-.231-.608-.506-.662Zm-.011 2.166a.978.978 0 0 1 .176.01c.286.075.506.342.506.715 0 .373-.231.65-.506.715l-.176.021h-1.452v-1.461h1.452Z',
        fill: '#fff',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_jcb__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(5 8)',
          d: 'M0 0h22v16H0z',
        }),
      ),
    ),
  );
});
jcbSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var jcb = {
  category: 'brand',
  colorable: false,
  name: 'jcb',
  svg: jcbSvg,
};
